import { Box, Center } from '@ssnc/bsds-core';

import { AuthGate } from './features/auth/AuthGate';
import { TenantPicker } from './features/tenant-picker/TenantPicker';

export function App() {
  return (
    <AuthGate>
      <Center maxWidth="80rem" gutters={300}>
        <Box element="main" padding={400}>
          <TenantPicker />
        </Box>
      </Center>
    </AuthGate>
  );
}
